import { render, staticRenderFns } from "./UnsubscribeNotificationConfirmation.vue?vue&type=template&id=33b0a14f"
import script from "./UnsubscribeNotificationConfirmation.vue?vue&type=script&lang=js"
export * from "./UnsubscribeNotificationConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports